import { Flex, Pane, Text } from '@leverege/ui-elements'
import { TitleBar, useSharedContext } from '@leverege/ui-plugin'
import React, { useMemo } from 'react'
import { getUtilizationStats } from '../../../../util'
import { formatDuration } from '../../../../util/Format'

import S from './Overview.css'

export default function Overview( { data, businessDays, loading } ) {
  const { timezone } = useSharedContext()

  const {
    services,
    totalOccupied,
    averageServiceLength,
    totalUnoccupied,
    percentOccupied,
    percentUnoccupied
  } = useMemo( () => {
    return getUtilizationStats( data, businessDays, 'dogInStation', undefined, timezone )
  }, [ data, businessDays, timezone ] )

  return (
    <Pane variant="card">
      <TitleBar
        variant="analyticsCardTitle|cardTitle"
        icon={loading ? 'fa fa-spin fa-circle-o-notch' : undefined}
        title="Overview" />
      <Flex
        justify="space-between"
        className={S.statsRow}>
        <Statistic
          label="Total Services"
          value={services.length} />
        <Statistic
          label="Avg Service Length"
          value={formatDuration( averageServiceLength, { daysToHours : true } )} />
        <Statistic
          label="Total Time Occupied"
          value={`${formatDuration( totalOccupied, { daysToHours : true } )} (${percentOccupied}%)`} />
        <Statistic
          label="Total Time Unoccupied"
          value={`${formatDuration( totalUnoccupied, { daysToHours : true } )} (${percentUnoccupied}%)`} />
      </Flex>
    </Pane>
  )
}

function Statistic( { label, value } ) {
  return (
    <Flex
      variant="colM">
      <Text variant="analyticsDetailLabel|detailLabel">{label}</Text>
      <Text variant="analyticsDetailValue|detailValue">{value}</Text>
    </Flex>
  )
}
